import type { EntityData, RequestErrorInfo } from '@/services/api/types';
import { OnboardingContent, Checkbox } from './Onboarding.styles';
import { type PopupProps, Popup } from '@/components/Popups';
import { RequestError } from '@CS/components/Popups';
import Button from '@CS/components/Button';
import { useTranslations } from '@/hooks';
import { useState } from 'react';
import API from '@/services/api';

type OnboardingProps = PopupProps & {
  onNext: () => void;
  data?: EntityData;
  step: number;
};

export const Onboarding = ({
  step,
  data,
  onNext,
  ...props
}: OnboardingProps) => {
  const [updateError, setUpdateError] = useState<RequestErrorInfo>();
  const onClick = () => (step === 2 ? onClose() : onNext());
  const cancelUpdate = () => setUpdateError(void 0);
  const [close, setClose] = useState(false);
  const [checked, setChecked] = useState(false);

  const onClose = () =>
    ~setClose(true) &&
    API.updateUser({
      data: {
        ...data,
        welcome: true,
        skipOnboarding: checked,
        onboardedAt: new Date().toISOString()
      }
    }).catch((error) => setUpdateError(API.getRequestErrorInfo(error)));

  const steps = useTranslations([
    '02OnboardingPopupFirstTitle',
    '02OnboardingPopupFirstDescription',
    '02OnboardingPopupFirstButton',

    // Second and third onboarding popup
    // translations were swaped by the client.
    '02OnboardingPopupThirdTitle',
    '02OnboardingPopupThirdDescription',
    '02OnboardingPopupThirdButton',

    '02OnboardingPopupSecondTitle',
    '02OnboardingPopupSecondDescription',
    '02OnboardingPopupSecondButton',
    '02OnboardingPopupThirdCheckbox'
  ]);

  const s = step * 3;
  const title = steps[s];
  const button = steps[s + 2];
  const description = steps[s + 1];

  return (
    <>
      <Popup {...props} overlay={false} close={close} hideClose>
        <OnboardingContent>
          <h2>{title}</h2>
          <p dangerouslySetInnerHTML={{ __html: description }} />

          {step === 2 && (
            <div>
              <label>
                <Checkbox
                  onChange={(e) => setChecked(e.target.checked)}
                  checked={checked}
                  type="checkbox"
                />
                {steps[9]}
              </label>
            </div>
          )}

          <Button text={button} onClick={onClick} />
        </OnboardingContent>
      </Popup>

      {updateError && (
        <RequestError info={updateError} onClose={cancelUpdate} />
      )}
    </>
  );
};
